import React from "react";
import { DA_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/RelewiseCategoryV1.component";

const featureName = "blockPLP";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const DA_ProductRelewiseList = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <DA_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

DA_ProductRelewiseList.displayName = "DA_ProductRelewiseList";
